var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SsrRoot,{attrs:{"kind":"header-ads","data":_vm.data}},[_c(_setup.HeaderAdsBanner,{attrs:{"ads":_vm.data.ads}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }